import React from "react";
import Snackbar from "@mui/material/Snackbar";

const SnackbarAlert = ({
  vertical,
  horizontal,
  snackbarSuccessOpen,
  handleCloseSnackbarSuccess,
  successMessage,
  snackbarErrorOpen,
  handleCloseSnackbarError,
  errorMessage,
}) => {
  return (
    <div>
      {/* SNACKBAR SUCCESS */}
      {successMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarSuccessOpen}
          autoHideDuration={5000}
          onClose={handleCloseSnackbarSuccess}
          key={vertical + horizontal}
        >
          <div className="zoom bg-green-500 text-white px-10 py-3 rounded-lg">
            {successMessage}
          </div>
        </Snackbar>
      ) : null}

      {/* SNACKBAR ERROR */}
      {errorMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={5000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
        >
          <div className="zoom bg-red-500 text-white px-10 py-3 rounded-lg">
            {errorMessage}
          </div>
        </Snackbar>
      ) : null}
    </div>
  );
};

export default SnackbarAlert;
